import { component$ } from "@builder.io/qwik";

export const ImageSparkle = component$(() => (
  <>
    <svg
      width="30"
      height="23"
      viewBox="0 0 42 35"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      class="absolute -right-5 -top-5"
    >
      <path
        d="M3 20.2931C3.41379 16.7759 4.24138 9.12069 4.24138 6.63793M31.5517 2.5L15 22.9828M23.069 32.5C27.2069 31.0517 36.1862 28.4448 39 29.6034"
        stroke="var(--orange-200)"
        stroke-width="4"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  </>
));
